import AppConstants from '../constants/AppConstants';

export const initialState = {
    offers: [],
    goals: [],
    goalActions: [],
    loadingOffers: false,
    loadingGoals: false,
    loadingGoalActions: false,
};

let type = '';

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.SELECT_GOAL_ACTIONS_START_LOADING:
            type = getTypeLoading(action.downloadType);

            return {
                ...state,
                [`loading${type}`]: true
            };

        case AppConstants.SELECT_GOAL_ACTIONS_SUCCESS:
            type = getTypeLoading(action.downloadType);

            return {
                ...state,
                [action.downloadType]: action.items.items,
                [`loading${type}`]: false
            };

        case AppConstants.SELECT_GOAL_ACTIONS_FAIL:
            return {
                ...state,
                loadingOffers: false,
                loadingGoals: false,
                loadingGoalActions: false
            };

        default:
            return state;
    }
};

const getTypeLoading = (type) => {
    return `${type[0].toUpperCase()}${type.slice(1)}`;
};
